<template>
    <div class="flex flex-col">
        <empty-list :message="empty" v-if="meetings.length == 0"></empty-list>
        <div
            class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8"
            not-class="{ 'pb-8': fullHeight }"
            v-if="meetings.length > 0"
        >
            <div
                class="
                    py-2
                    align-middle
                    inline-block
                    min-w-full
                    sm:px-6
                    lg:px-8
                "
            >
                <input
                    v-model="search"
                    autocomplete="false"
                    spellcheck="false"
                    type="search"
                    class="form-input block w-full text-md sm:leading-5 hidden"
                    placeholder="Naar wie bent u opzoek?"
                />
                <div
                    class="
                        shadow
                        overflow-auto
                        border-b border-gray-200
                        sm:rounded-lg
                        min-h-full
                    "
                    no-style="min-height: 60vh"
                    :style="
                        fullHeight
                            ? 'min-height: 100vh!important'
                            : 'min-height: 40vh!important'
                    "
                >
                    <table
                        class="min-w-full divide-y divide-gray-200 table-auto"
                    >
                        <thead class="bg-blue-800">
                            <tr>
                                <th
                                    scope="col"
                                    class="
                                        px-6
                                        py-3
                                        text-left text-xs
                                        font-medium
                                        text-gray-50
                                        uppercase
                                        tracking-wider
                                        hidden
                                    "
                                >
                                    <input
                                        type="checkbox"
                                        class="
                                            h-5
                                            w-5
                                            text-blue-600
                                            focus:ring-blue-500
                                            border-gray-300
                                            rounded
                                            hover:opacity-100
                                        "
                                        :class="{ 'opacity-60': !checkAll }"
                                        v-model="checkAll"
                                    />
                                </th>
                                <th
                                    scope="col"
                                    class="
                                        px-6
                                        py-3
                                        text-left text-xs
                                        font-medium
                                        text-gray-50
                                        uppercase
                                        tracking-wider
                                    "
                                >
                                    {{ t("meeting.title", "Titel") }}
                                </th>
                                <th
                                    scope="col"
                                    class="
                                        px-6
                                        py-3
                                        text-left text-xs
                                        font-medium
                                        text-gray-50
                                        uppercase
                                        tracking-wider
                                    "
                                >
                                    {{ t("meeting.date", "Datum") }}
                                </th>
                                <th
                                    scope="col"
                                    class="
                                        px-6
                                        py-3
                                        text-left text-xs
                                        font-medium
                                        text-gray-50
                                        uppercase
                                        tracking-wider
                                        align-right
                                    "
                                >
                                    {{ t("meeting.details", "Details") }}
                                </th>
                            </tr>
                        </thead>
                        <tbody class="bg-gray-50 divide-y divide-gray-200">
                            <meeting
                                v-for="(meeting, personIdx) in filteredList"
                                r
                                :class="
                                    personIdx % 2 === 0
                                        ? 'bg-white'
                                        : 'bg-gray-50'
                                "
                                :meeting="meeting"
                                :key="meeting.id"
                            >
                            </meeting>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EmptyList from "./EmptyList.vue";
import Meeting from "./Meeting.vue";
export default {
    components: { EmptyList, Meeting },
    mounted() {
        Eventing.listen("tableFullHeight", () => (this.fullHeight = true));
    },
    created() {
        // this.empty = "In deze lijst zijn (nog) geen vergaderingen beschikbaar";
        this.empty = this.t(
            "meetings.empty-list",
            "In deze lijst zijn (nog) geen vergaderingen beschikbaar"
        );
    },
    props: ["meetings"],
    data() {
        return {
            checkAll: false,
            search: null,
            empty: null,
            fullHeight: false,
        };
    },
    computed: {
        filteredList() {
            if (!this.search) return this.meetings;
            var find = function (object, search) {
                for (var property in object) {
                    if (object.hasOwnProperty(property)) {
                        if (typeof object[property] == "object") {
                            find(object[property]);
                        } else if (object[property].includes !== undefined) {
                            if (object[property].toLowerCase().includes(search))
                                return true;
                        }
                    }
                }
                return false;
            };
            return this.meetings.filter((_item) => {
                return find(_item, this.search.toLowerCase());
            });
        },
    },
    watch: {
        checkAll: function (val) {
            if (val == true) {
                this.meetings.forEach((item) => {
                    item.checked = true;
                });
            } else {
                this.meetings.forEach((item) => {
                    item.checked = false;
                });
            }
        },
    },
};
</script>
